module.exports = __webpack_public_path__ + "static/media/game-score.12a1a9a2.svg";